<template>
  <div class="Tooltip">
    <div
      class="Tooltip__inner"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave"
      :style="computedStyle"
    >
      <slot />
      <span
        v-if="hover"
        class="Tooltip__balloon"
        :class="directionClass"
        :style="width"
        >{{ text }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'TooltipBase',
  props: {
    text: {
      type: String,
      default: '',
    },
    size: {
      type: [Number, String],
      default: '',
    },
    direction: {
      type: String,
      default: 'up',
    },
    left: {
      type: [String, Number],
      default: '',
    },
    afterLeft: {
      type: [String, Number],
      default: '',
    },
    top: {
      type: [String, Number],
      default: '',
    },
    afterTop: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    width() {
      return {
        '--width': `${this.size}px`,
      };
    },
    directionClass() {
      return 'Tooltip__balloon--' + this.direction;
    },
    computedStyle() {
      return {
        '--tooltip-left': this.left ? this.left : '50%',
        '--tooltip-after-left': this.afterLeft ? this.afterLeft : '50%',
        '--tooltip-left-transform': this.left ? 'none' : 'translate(-50%, 0)',
        '--tooltip-top': this.top ? this.top : '50%',
        '--tooltip-after-top': this.afterTop ? this.afterTop : '50%',
        '--tooltip-top-transform': this.top ? 'none' : 'translate(0, -50%)',
      };
    },
  },
  methods: {
    mouseOver() {
      if (this.text === '') {
        return false;
      }
      this.hover = true;
    },
    mouseLeave() {
      this.hover = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.Tooltip {
  &__inner {
    position: relative;
    display: inline-block;
  }

  &__balloon {
    position: absolute;
    z-index: $service-z-index-ff;
    // bottom: calc(100% + $service-unit);
    // left: 50%;
    display: inline-block;
    width: var(--width);
    padding: $service-unit $service-unit * 2;
    font-size: $service-font-size-pp;
    line-height: $service-line-height-mp;
    color: $color-white-100;
    white-space: nowrap;
    background-color: $color-black-100;
    border-radius: $service-unit;
    box-shadow: $service-shadow-p;
    //transform: translateX(-50%);

    &::after {
      position: absolute;
      // top: 100%;
      // left: 50%;
      content: '';
      border: 5px solid transparent;
      // border-top: 5px solid $color-black-100;
      // transform: translateX(-50%);
    }

    &--up {
      bottom: calc(100% + $service-unit);
      left: var(--tooltip-left);
      transform: var(--tooltip-left-transform);

      &::after {
        top: 100%;
        left: var(--tooltip-after-left);
        border-top: 5px solid $color-black-100;
        transform: var(--tooltip-left-transform);
      }
    }

    &--down {
      top: calc(100% + $service-unit);
      left: var(--tooltip-left);
      transform: var(--tooltip-left-transform);

      &::after {
        bottom: 100%;
        left: var(--tooltip-after-left);
        border-bottom: 5px solid $color-black-100;
        transform: var(--tooltip-left-transform);
      }
    }

    &--right {
      top: var(--tooltip-top);
      left: calc(100% + $service-unit);
      transform: var(--tooltip-top-transform);

      &::after {
        top: var(--tooltip-after-top);
        left: -10px;
        border-right: 5px solid $color-black-100;
        transform: var(--tooltip-top-transform);
      }
    }

    &--left {
      top: var(--tooltip-top);
      right: calc(100% + $service-unit);
      transform: var(--tooltip-top-transform);

      &::after {
        top: var(--tooltip-after-top);
        right: -10px;
        border-left: 5px solid $color-black-100;
        transform: var(--tooltip-top-transform);
      }
    }
  }
  @media (max-width: 1024px) {
    &__balloon {
      display: none;
    }
  }
}
</style>
